import Alert from "@mui/material/Alert";

export default function FeedbackBanner(props) {
  const { banner } = props;

  return (
    banner.message && <Alert severity={banner.severity}>{banner.message}</Alert>
  );
}
